import { render, staticRenderFns } from "./SubMenu.vue?vue&type=template&id=abb99818"
import script from "./SubMenu.vue?vue&type=script&lang=js"
export * from "./SubMenu.vue?vue&type=script&lang=js"
import style0 from "./SubMenu.vue?vue&type=style&index=0&id=abb99818&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports